<ng-container *ngIf="products$ | async as products">
  <ng-container *ngFor="let product of products; let index = index">
    <div *ngIf="!!product" class="extra-small-item-wrapper mb-4">
      <cx-generic-link [url]="getUrl(product?.url)" class="extra-small-item-link">
        <div class="extra-small-item">
          <py-badge class="pt-4 pl-4" [large]="true" [tag]="true" [showCircle]="false" [type]="badgeType">
            {{ 'product.campaign_badge' | cxTranslate }}
          </py-badge>

          <div *ngIf="product?.images && product?.images?.length; else noImageTemplate" class="extra-small-item-image pt-4 px-4">
            <img [format]="'default'" [pyMedia]="{ default: product.images[0] }" [alt]="product?.name" />
          </div>
          <span class="extra-small-item-description mt-4 pb-4 px-4">{{ product?.name }}</span>
        </div>
      </cx-generic-link>
    </div>

    <ng-template #noImageTemplate>
      <div class="d-flex justify-content-center pt-6 mb-2">
        <i nz-icon nzType="picture" class="no-image-icon"></i>
      </div>
    </ng-template>

    <div *ngIf="!product" class="extra-small-item-wrapper mb-4" style="min-height: 200px">
      <div class="skeleton h-100 w-100"></div>
    </div>
  </ng-container>
</ng-container>
